<template>
	<BaseCmsPage v-slot="{page}" @load="onPageLoad" thumb-preset="page">
		<div class="wrapper">
			<CmsBreadcrumbs class="bc-contact" :items="page?.breadcrumbs || []" />
			
			<CmsCardLarge class="only-image" v-if="page?.main_image_upload_path">
				<template #header>
					<BaseUiImage :data="page?.main_image_upload_path_thumb" default="/images/no-image-1440.jpg" />
				</template>
			</CmsCardLarge>

			<div class="wrapper2">
				<CmsContent v-if="page?.content">
					<h1 v-if="page?.title" v-html="page?.title" />
					<div class="lists" v-if="page?.content" v-html="page.content" v-interpolation />
					<div id="cookies-list"></div>
				</CmsContent>
			</div>
		</div>
	</BaseCmsPage>
</template>

<script setup>
	const {gtmTrack} = useGtmBB();
	const {addScript} = useMeta();
	function onPageLoad(data) {
		if(!data) return;
		gtmTrack('virtualPageview', {
			url: data?.url || '',
			title: data?.title || '',
		});
		if(data.code == 'cookies') {
			addScript({
				key: 'CookieDeclaration',
				id: 'CookieDeclaration',
				src: 'https://consent.cookiebot.com/fa5cc7bc-60c8-4345-9a62-ebcb3da401f8/cd.js',
				type: 'text/javascript',
				async: true,
				appendTo: '#cookies-list'
			});
		}
	}
</script>